import React, { useContext } from 'react';

import {
  INTEGRATE_ENV_TYPE,
} from '@bingads-webui-campaign-react/smart-component-util';

export const IntegrationContext = React.createContext(INTEGRATE_ENV_TYPE.STANDALONE);

export const useIntegrationContext = () => useContext(IntegrationContext);

export const useIsHookedInWizard = () => {
  const env = useIntegrationContext();
  return env ===
    INTEGRATE_ENV_TYPE.UP_WIZARD
    || env === INTEGRATE_ENV_TYPE.SUB_ADS_WIZARD
    || env === INTEGRATE_ENV_TYPE.SUB_ADS_WIZARD2
    || env === INTEGRATE_ENV_TYPE.STREAMLINED_WIZARD
    || env === INTEGRATE_ENV_TYPE.PMAX_LITE_WIZARD;
};

export const useIsSubAdsIntegration = () => {
  const env = useIntegrationContext();
  return env === INTEGRATE_ENV_TYPE.SUB_ADS_WIZARD || env === INTEGRATE_ENV_TYPE.SUB_ADS_WIZARD2;
};

export const useIsSubAds2Integration = () => {
  const env = useIntegrationContext();
  return env === INTEGRATE_ENV_TYPE.SUB_ADS_WIZARD2;
};

export const useIsUpIntegration = () => {
  const env = useIntegrationContext();
  return env === INTEGRATE_ENV_TYPE.UP_WIZARD;
};

export const useIsSmartPageStandalone = () => {
  const env = useIntegrationContext();
  return env === INTEGRATE_ENV_TYPE.STANDALONE;
};

export const useIsStreamlinedIntegration = () => {
  const env = useIntegrationContext();
  return env === INTEGRATE_ENV_TYPE.STREAMLINED_WIZARD;
};

export const useIsPmaxLiteIntegration = () => {
  const env = useIntegrationContext();
  return env === INTEGRATE_ENV_TYPE.PMAX_LITE_WIZARD;
};
